import { render } from "./EventsCard.vue?vue&type=template&id=7a91f3c2"
import script from "./EventsCard.vue?vue&type=script&lang=js"
export * from "./EventsCard.vue?vue&type=script&lang=js"
script.render = render

export default script